import React, { useCallback } from 'react';
import type { CheckboxOption } from '@/components/Filters/CheckboxFilterSidebar';
import { CheckboxFilterSidebar } from '@/components/Filters/CheckboxFilterSidebar';

export type FilterMode = 'any' | 'all';

export type ParticipantOption = {
    value: string;
    label: string;
};

type Props = {
    participants: ParticipantOption[];
    selected: string[];
    onChangeSelected: (ids: string[]) => void;

    mode: FilterMode;
    onChangeMode: (m: FilterMode) => void;

    onResetAll?: () => void;
    maxHeight?: number | string;
    showReset?: boolean;
};

export const VideoFiltersSidebar: React.FC<Props> = ({
                                                         participants,
                                                         selected,
                                                         onChangeSelected,
                                                         mode,
                                                         onChangeMode,
                                                         onResetAll,
                                                         maxHeight = '60vh',
                                                         showReset = false,
                                                     }) => {
    const handleReset = useCallback(() => {
        // Keep the same behavior you had.
        onChangeMode('any');
        onResetAll?.();
    }, [onChangeMode, onResetAll]);

    const options: CheckboxOption[] = participants;

    return (
        <CheckboxFilterSidebar
            title="Filter videos"
            options={options}
            selected={selected}
            onChangeSelected={onChangeSelected}
            maxHeight={maxHeight}
            showReset={showReset}
            onResetAll={handleReset}
            emptyText="No matches"
        />
    );
};
